export default __webpack_public_path__ + "2e6d6b68e4e2f8aca22bf6b1f2a781ad.png";